import { ModelResource } from './resource';
import { Profile, User } from '../models';

export class Profiles extends ModelResource<Profile> {
  model = Profile;

  resourcePath = 'v1/profile';

  async switchTenant(organizationId: string): Promise<Profile> {
    return this.api.post(this.path('switch', organizationId)).then((response) => {
      return Profile.fromJson(response.data);
    });
  }

  async updateDashboardSettings(
    settings: {
      thread_emails_sort_order: string;
    },
    profile?: Profile,
  ): Promise<Profile> {
    return this.api.post(this.path('dashboard-settings'), { data: settings }).then((response) => {
      if (profile) {
        profile.updateFromJson(response.data);
        return profile;
      }

      return Profile.fromJson(response.data);
    });
  }
}
